module.exports = __webpack_public_path__ + "img/parallax-orange.e67e864e.jpg";